import React, { useContext } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'

import AppContext from './AppContext'
import PdfGenerator from './PdfGenerator'

const CreateInvoice = () => {
  const { control, register, handleSubmit, watch, setValue } = useForm()
  const myContext = useContext(AppContext)

  const onSubmit = data => console.log(data)
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items'
  })
  const taxItemsArray = useFieldArray({
    control,
    name: 'tax'
  })

  const watchAllFields = watch()

  const today = new Date().toISOString().substring(0, 10)
  const defaultDue = new Date(Date.now() + 10 * 24 * 60 * 60 * 1000)
    .toISOString()
    .substring(0, 10)

  React.useEffect(() => {
    setValue('date', today)
    setValue('dueDate', defaultDue)
    setValue('currency', myContext.currency)
    setValue('items', [
      {
        itemName: 'Testing',
        qty: 1,
        cost: 1000
      }
    ])
    setValue('tax', [
      {
        name: 'GST',
        percentage: 18
      }
    ])
  }, [setValue, today, defaultDue, myContext.currency])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col sm:flex-row">
          <div className="w-full md:w-1/3 flex flex-col bg-gray-200 p-5">
            <div className="field">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Invoice Details
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="field">
                <label htmlFor="date">Invoice Date</label>
                <input
                  type="date"
                  placeholder="Invoice Date"
                  {...register('date')}
                />
              </div>
              <div className="field">
                <label htmlFor="date">Invoice Due</label>

                <input
                  type="date"
                  placeholder="Invoice Due Date"
                  {...register('dueDate')}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="field">
                <label htmlFor="date">Currency</label>
                <input
                  type="text"
                  placeholder="Currency"
                  {...register('currency')}
                />
              </div>
              <div className="field">
                <label htmlFor="date">Line </label>
                <input
                  type="text"
                  placeholder="Invoice ID"
                  {...register('invoiceId')}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="field">
                <label htmlFor="date">Cleint ID</label>
                <input
                  type="text"
                  placeholder="Client ID"
                  {...register('clientId')}
                />
              </div>
              <div className="field">
                <label htmlFor="date">Client Details</label>

                <textarea
                  placeholder="Client address"
                  {...register('clientAddress')}
                />
              </div>
            </div>

            <div className="w-full  flex flex-col gap-3">
              <div className="field">
                <label htmlFor="date">Line Items</label>
                {fields.map((item, index) => (
                  <div
                    className="grid grid-cols-3 gap-3 my-3"
                    key={`item-${index}`}>
                    <input
                      type="text"
                      placeholder="Item Name"
                      {...register(`items.${index}.itemName`)}
                      defaultValue={item.itemName}
                    />
                    <input
                      type="number"
                      placeholder="Qualtity"
                      {...register(`items.${index}.qty`)}
                      defaultValue={item.qty}
                    />
                    <input
                      type="number"
                      placeholder="Cost"
                      {...register(`items.${index}.cost`)}
                      defaultValue={item.cost}
                    />
                    {index > 0 && (
                      <button
                        type="button"
                        className="text-red-900 "
                        onClick={() => remove(index)}>
                        remove
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <div className="field">
                <button
                  className="w-2/6 p-2 bg-blue-700 text-white mb-2"
                  onClick={() =>
                    append({
                      itemName: '',
                      qty: '',
                      cost: ''
                    })
                  }>
                  Add Item
                </button>
              </div>

              <div className="field">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  Tax Details
                </h3>
              </div>

              {taxItemsArray.fields.map((taxItem, index) => (
                <div
                  className="grid grid-cols-3 gap-3 my-3 field"
                  key={`taxItem-${index}`}>
                  <input
                    type="text"
                    placeholder="Tax Name"
                    {...register(`tax.${index}.name`)}
                    defaultValue={taxItem.name}
                  />

                  <input
                    type="number"
                    placeholder="Amount %"
                    {...register(`tax.${index}.percentage`)}
                    defaultValue={taxItem.percentage}
                  />

                  <button
                    type="button"
                    className="text-red-900 "
                    onClick={() => taxItemsArray.remove(index)}>
                    remove
                  </button>
                </div>
              ))}
              <div className="field">
                <button
                  className="w-2/6 p-2 bg-blue-700 text-white mb-2"
                  onClick={() =>
                    taxItemsArray.append({
                      name: '',
                      percentage: ''
                    })
                  }>
                  Add Item
                </button>
              </div>
              <div className="field">
                <label htmlFor="date">Footer Text</label>
                <textarea
                  type="text"
                  placeholder="Footer Text"
                  {...register('footerId')}
                />
              </div>
            </div>
          </div>
          <div className="w-full md:w-8/12 flex flex-col bg-gray-200 p-5">
            <PdfGenerator invoice={watchAllFields} />
          </div>
        </div>
      </form>
    </>
  )
}

export default CreateInvoice
